<!-- 球员管理 -->
<template>
    <div>
        <div><normal-title title="查看球员"></normal-title></div>
        <div class="bottom_btn">
            <el-button icon="el-icon-back" type="text" title="返回" class="back" @click="backPage()"></el-button>
            <el-button type="primary" class="addVenue" @click="addplayer">新增</el-button>
        </div>
        <div class="hideTable">
            <el-table :data="playerData">
                <el-table-column label="序号" prop="playerId" align="center" width="60"></el-table-column>
                <el-table-column label="头像" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.playerPic" style="width: 50px;height:50px"
                            @click="editLogo(scope.row)"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="姓名" prop="playerName" align="center"></el-table-column>
                <el-table-column label="球衣尺码" prop="shirtSize" align="center"></el-table-column>
                <el-table-column label="球衣号" prop="playerNumber" align="center"></el-table-column>
                <el-table-column label="位置" prop="playPosition" align="center"></el-table-column>
                <el-table-column label="入队时间" prop="createTime" align="center"></el-table-column>
                <el-table-column label="类型" prop="joinType" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.joinType == 0">自行入队</span>
                        <span v-if="scope.row.joinType == 1">编辑入队</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="deletePlayer(scope.row)">删除</el-button>
                        <el-button type="text" @click="editPlayer(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :visible.sync="dialogVisible" :title="title" width="50%" @close="closeDialog">
            <el-form ref="form" :model="form" label-width="80px" class="infoForm" :rules="rules">
                <el-row :gutter="20">
                    <el-col>
                        <el-form-item label="头像" prop="playerPic">
                            <f-image-upload v-model="form.playerPic" style="margin-left: 0" :width="'100px'"
                                :height="'100px'"></f-image-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="姓名" prop="playerName">
                            <el-input v-model="form.playerName" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="位置">
                            <el-select v-model="form.playPosition" placeholder="请选择球员位置">
                                <el-option v-for="item in playPosition" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="球员ID">
                            <el-input v-model="form.personNo" placeholder="请输入球员ID"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="球衣号" prop="playerNumber">
                            <el-input v-model="form.playerNumber" placeholder="请输入球衣号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="球员类型" prop="memberType">
                            <el-select v-model="form.memberType" placeholder="请选择球员类型">
                                <el-option v-for="item in memberType" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="球衣尺码">
                            <el-select v-model="form.shirtSize" placeholder="请选择球衣尺码">
                                <el-option v-for="item in shirtSize" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="commitPlayer()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import FImageUpload from '@/common/components/Upload/f-image-upload.vue';
import NormalTitle from '@/common/components/normal/NormalTitle';
export default {
    components: { FImageUpload, NormalTitle },
    data() {
        return {
            dialogVisible: false,
            matchList: [],
            matchInfo: {},
            playerData: [],
            Jersey: [{
                value: "红色",
                label: "红色"
            },
            {
                value: "橙色",
                label: "橙色"
            },
            {
                value: "黄色",
                label: "黄色"
            },
            {
                value: "绿色",
                label: "绿色"
            },
            {
                value: "蓝色",
                label: "蓝色"
            },
            {
                value: "黑色",
                label: "黑色"
            },
            {
                value: "紫色",
                label: "紫色"
            }],
            playerType: [
                {
                    value: "自行入队",
                    label: "自行入队"
                },
                {
                    value: "编辑入队",
                    label: "编辑入队"
                }
            ],
            playPosition: [{
                value: "守门员",
                label: "守门员"
            },
            {
                value: "中卫",
                label: "中卫"
            },
            {
                value: "边后卫",
                label: "边后卫"
            },
            {
                value: "后腰",
                label: "后腰"
            },
            {
                value: "中场",
                label: "中场"
            },
            {
                value: "前腰",
                label: "前腰"
            },
            {
                value: "边锋",
                label: "边锋"
            },
            {
                value: "前锋",
                label: "前锋"
            },
            {
                value: "自由人",
                label: "自由人"
            },
            {
                value: "清道夫",
                label: "清道夫"
            },
            {
                value: "领队",
                label: "领队"
            },
            {
                value: "裁判",
                label: "裁判"
            },
            {
                value: "教练",
                label: "教练"
            }],
            shirtSize: [
                {
                    value: "S",
                    label: "S"
                },
                {
                    value: "M",
                    label: "M"
                },
                {
                    value: "L",
                    label: "L"
                },
                {
                    value: "XL",
                    label: "XL"
                },
                {
                    value: "2XL",
                    label: "2XL"
                },
                {
                    value: "3XL",
                    label: "3XL"
                },
                {
                    value: "4XL",
                    label: "4XL"
                }],
            memberType: [
                {
                    value: 0,
                    label: "队长"
                },
                {
                    value: 1,
                    label: "队员"
                }],
            form: {},
            title: '',
            rules: {
                playerPic: [{ required: true, message: '上传', trigger: 'change' }],
                playerName: [{ required: true, message: '请输入', trigger: 'blur' }],
                matchTeamId: [{ required: true, message: '请选择', trigger: 'change' }],
                playerNumber: [{ required: true, message: '请输入', trigger: 'blur' }],
                memberType: [{ required: true, message: '请选择', trigger: 'change' }]
            },
        };
    },
    mounted() {
        this.getPlayerList()
    },
    methods: {
        // 获取球员
        async getPlayerList() {
            const { res } = await this.$http.get(`/Match/TeamPlayerList/${this.$route.query.teamId}`);
            this.playerData = res.data || [];
        },
        // 保存球员
        commitPlayer() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.form.matchTeamId = this.$route.query.teamId
                    this.form.matchId = this.$route.query.matchId
                    this.$confirm('请核实信息，确定要添加该球员吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(async () => {
                        const { res } = await this.$http.post('/Match/SaveTeamPlayer', this.form);
                        if (res.isSuccess) {
                            this.$showSuccess('发布成功');
                            this.dialogVisible = false
                            this.getPlayerList();
                        }
                    });
                } else {
                    this.$message.error("请填写完整信息！");
                    return
                }
            })
        },
        // 删除球员
        deletePlayer(row) {
            const playerId = row.playerId
            this.$confirm('确认要删除该球员吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                const { res } = await this.$http.post(`/Match/DeletePlayer/${this.$route.query.matchId}/${playerId}`);
                if (res.isSuccess) {
                    this.$showSuccess('删除成功');
                    this.getPlayerList();
                } else {
                    this.$showError(res.msg)
                }
            });
        },
        // 返回上一页
        backPage() {
            this.$router.back(-1)
        },
        closeDialog() {
            this.dialogVisible = false;
            this.title = '';
            this.form = {};
        },
        // 修改球员信息
        editPlayer(row) {
            this.dialogVisible = true
            this.title = "修改球员信息"
            this.form = this.cloneDeep(row);
        },
        // 新增球员
        addplayer() {
            this.dialogVisible = true,
                this.title = "新增球员"
        },
        // 深拷贝
        cloneDeep(target) {
            // 传入null，还是返回null
            if (target === null) {
                return target;
            }
            // 判断是否是对象
            if (typeof target === 'object') {
                // 兼容数组与对象
                let obj = Array.isArray(target) ? [] : {};
                for (let key in target) {
                    obj[key] = this.cloneDeep(target[key]);
                }
                return obj;
            } else {
                return target;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.back {
    font-size: 18px;
}

.bottom_btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;

    .addVenue {
        color: #fff;
    }
}

/deep/.el-input--small .el-input__inner {
    color: #e9e9e9;
}
</style>